import {getColumnIds, getDefaultVisibleIds} from '@eitje/web_components'
import {columns} from './columns'

export const TABLE_INFO = {
	fields: getColumnIds(columns),
	defaultVisibleColumns: getDefaultVisibleIds(columns),
	tableName: 'environments',
	recordType: 'environment',
}
